module.exports = __webpack_public_path__ + "static/media/6.97599cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pu-detail/6.png
// module id = 628
// module chunks = 0